import { APP_BASE_HREF } from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { ApolloModule } from "apollo-angular";

import { environment } from "../../environments/environment";
import { SharedModule } from "../shared/shared.module";
import { FallbackSrcDirective } from "../shared/directives/fallback-src.directive";
import { ProductImageSrcPipe } from "../shared/pipes/product-image-src.pipe";

import { APOLLO_CLIENT_PROVIDER } from "./apollo-client-provider";
import { AccountLinkComponent } from "./components/account-link/account-link.component";
import { AssetGalleryComponent } from "./components/asset-gallery/asset-gallery.component";
import { CartDrawerComponent } from "./components/cart-drawer/cart-drawer.component";
import { CartToggleComponent } from "./components/cart-toggle/cart-toggle.component";
import { CollectionBreadcrumbsComponent } from "./components/collection-breadcrumbs/collection-breadcrumbs.component";
import { CollectionsMenuMobileComponent } from "./components/collections-menu-mobile/collections-menu-mobile.component";
import { CollectionsMenuComponent } from "./components/collections-menu/collections-menu.component";
import { LayoutFooterComponent } from "./components/layout/layout-footer.component";
import { LayoutHeaderComponent } from "./components/layout/layout-header.component";
import { LayoutComponent } from "./components/layout/layout.component";
import { MobileMenuToggleComponent } from "./components/mobile-menu-toggle/mobile-menu-toggle.component";
import { ProductCardComponent } from "./components/product-card/product-card.component";
import { ProductDetailComponent } from "./components/product-detail/product-detail.component";
import { ProductListControlsComponent } from "./components/product-list-controls/product-list-controls.component";
import { ProductListComponent } from "./components/product-list/product-list.component";
import { ProductSearchBarComponent } from "./components/product-search-bar/product-search-bar.component";
import { ShippingDateFilterComponent } from "./components/shipping-date-filter/shipping-date-filter.component";
import { MovFilterComponent } from "./components/mov-filter/mov-filter.component";
import { SupplyTypeFilterComponent } from "./components/supply-type-filter/supply-type-filter.component";
import { TopReviewsComponent } from "./components/top-reviews/top-reviews.component";
import { PricelistsPageComponent } from "./components/pricelists-page/pricelists-page.component";
import { LimitedOffersComponent } from "./components/limited-offers/limited-offers.component";
import { BrandsPageComponent } from "./components/brands-page/brands-page.component";
import { buildIconLibrary } from "./icon-library";
import { DefaultInterceptor } from "./providers/data/interceptor";
import { CartComponent } from "./components/cart/cart.component";
import { ProductListZoomModalComponent } from "./components/product-list/components/product-list-zoom-modal/product-list-zoom-modal.component";
import { ProductListPaginationComponent } from "./components/product-list/components/product-list-pagination/product-list-pagination.component";
import { ProductListHeaderComponent } from "./components/product-list/components/product-list-header/product-list-header.component";
import { ProductListSupplierCardComponent } from "./components/product-list/components/product-list-supplier-card/product-list-supplier-card.component";
import { ProductListGridItemComponent } from "./components/product-list/components/product-list-grid-item/product-list-grid-item.component";
import { RetailPriceHintComponent } from "./components/product-list/components/retail-price-hint/retail-price-hint.component";

const CORE_COMPONENTS = [
    ProductListComponent,
    ProductDetailComponent,
    CartToggleComponent,
    AccountLinkComponent,
    CartDrawerComponent,
    LayoutComponent,
    LayoutHeaderComponent,
    LayoutFooterComponent,
    CollectionsMenuComponent,
    CollectionsMenuMobileComponent,
    MobileMenuToggleComponent,
    ProductCardComponent,
    CollectionBreadcrumbsComponent,
    ProductListControlsComponent,
    ShippingDateFilterComponent,
    MovFilterComponent,
    SupplyTypeFilterComponent,
    ProductSearchBarComponent,
    AssetGalleryComponent,
    CartComponent,
    PricelistsPageComponent,
    LimitedOffersComponent,
    BrandsPageComponent,
    ProductListZoomModalComponent,
    ProductListPaginationComponent,
    ProductListHeaderComponent,
    ProductListSupplierCardComponent,
    ProductListGridItemComponent,
    RetailPriceHintComponent,
];

@NgModule({
    declarations: [...CORE_COMPONENTS, TopReviewsComponent],
    imports: [
        HttpClientModule,
        SharedModule,
        BrowserModule,
        ApolloModule,
        ProductImageSrcPipe,
        FallbackSrcDirective,
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: DefaultInterceptor,
            multi: true,
        },
        { provide: APP_BASE_HREF, useValue: environment.baseHref },
        APOLLO_CLIENT_PROVIDER,
    ],
    exports: [...CORE_COMPONENTS],
})
export class CoreModule {
    constructor(library: FaIconLibrary) {
        buildIconLibrary(library);
    }
}
